import { render, staticRenderFns } from "./BatchFilter.vue?vue&type=template&id=c4c3f058&scoped=true"
import script from "./BatchFilter.vue?vue&type=script&lang=ts"
export * from "./BatchFilter.vue?vue&type=script&lang=ts"
import style0 from "./BatchFilter.vue?vue&type=style&index=0&id=c4c3f058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c3f058",
  null
  
)

export default component.exports